<template>
  <AppSection id="languages" :title="$getConst.pages.scope.jobs_logs" type="page">
    <div>
      <b-form-group id="language" :label="$t($getConst.pages.scope.scopes)" label-for="language-input">
        <multiselect
          v-model="scope"
          track-by="id"
          label="name"
          :placeholder="$t(this.$getConst.pages.form.select_option)"
          :options="$store.getters['auth/allScopes']"
          :show-labels="false"
          :searchable="true"
          @input="changeScope"
        >
          <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
        </multiselect>
      </b-form-group>
    </div>
    <AppDataTable
      :key="tableKey"
      ref="commandLogsTable"
      :fields="fields"
      :end-point="endPoint"
      :actions="actions"
      @onShowImportTimesheetsReport="showImportTimesheetsReportModal"
      @onShowImportInvoicesReport="showImportInvoicesReportModal"
      sort-by="created_at"
      sort-desc
      refresh-button
    >

      <template v-slot:properties="item">
        <b-link @click="showPropertiesDetails(item.row)" v-b-tooltip.hover
                  :title="$getConst.pages.button.show_more"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

      <template v-slot:details="item">
        <template v-if="item.data.length > 10">
          {{ item.data.substr(0, 30)  }} ...
          <b-link @click="showDetails(item.row)" v-b-tooltip.hover
                  :title="$getConst.pages.button.show_more"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
        </template>
      </template>

      <template v-slot:causer_id="item">
        <template v-if="item.data!=null">
          {{item.data.name}}
        </template>
      </template>

      <template v-slot:status="item">
        <b-badge v-if="item.data === 'Report done' || item.data === 'Import done'" variant="success" pill>{{ item.data }}</b-badge>
        <b-badge v-else-if="item.data === 'Report failed' || item.data === 'Import failed' || item.data === 'Invalid data'" variant="danger" pill>{{ item.data }}</b-badge>
        <b-badge v-else-if="item.data === 'Import in progress' || item.data === 'Report in progress'" variant="warning" pill>{{ item.data }}</b-badge>
        <b-badge v-else variant="secondary" pill>{{ item.data }}</b-badge>
      </template>

      <template #button-onShowImportTimesheetsReport="{action, rowData}">
        <b-button
          v-if="rowData.log_name === 'Import timesheets' && showVendorReportButton(rowData)"
          :variant="action.variant"
          class="ml-2 border-0"
          size="sm"
          @click="showImportTimesheetsReportModal(rowData)">
          <i :class="action.icon"></i>
        </b-button>
        <template v-else>
          &nbsp;
        </template>
      </template>

      <template #button-onShowImportInvoicesReport="{action, rowData}">
        <b-button
          v-if="rowData.log_name === 'Import invoices' && showVendorReportButton(rowData)"
          :variant="action.variant"
          class="ml-2 border-0"
          size="sm"
          @click="showImportInvoicesReportModal(rowData)">
          <i :class="action.icon"></i>
        </b-button>
        <template v-else>
          &nbsp;
        </template>
      </template>

      <template v-slot:created_at="item">
        {{formatDate(item.data)}}
      </template>
    </AppDataTable>
    <ShowLogPropertiesDetailsModal v-if="log" :log="log" :id="propertiesDetailsModal" size="xl"></ShowLogPropertiesDetailsModal>
    <ShowLogDetailsModal v-if="log" :log="log" :id="detailsModal" size="xl"></ShowLogDetailsModal>
    <ImportTimesheetsReportModal v-if="log" :log="log" :id="importTimesheetsReportModal" @dispatchImportTimesheetsJob="tableKey++"></ImportTimesheetsReportModal>
    <ImportInvoicesReportModal v-if="log" :log="log" :id="importInvoicesReportModal" @dispatchImportInvoicesJob="tableKey++"></ImportInvoicesReportModal>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppDataTable from "../../../../components/common/table/AppDataTable";
  import ShowLogPropertiesDetailsModal from "./ShowLogPropertiesDetailsModal";
  import ShowLogDetailsModal from "./ShowLogDetailsModal";
  import ImportTimesheetsReportModal from "./ImportTimesheetsReportModal";
  import {formatDateByScope} from "../../../../shared/services/date";
  import ImportInvoicesReportModal from "./ImportInvoicesReportModal";
  import {getAllStatus} from "../../../../api/commandLogs.api";

  export default {
    name: "commandLogs",
    components: {
      ImportInvoicesReportModal,
      ImportTimesheetsReportModal,
      ShowLogDetailsModal, ShowLogPropertiesDetailsModal, AppSection, AppDataTable},
    data() {
      return {
        endPoint: null,
        fields: [
          {key: 'log_name', label: 'name', sortable: true, filterable: true},
          {key: 'description', sortable: true, filterable: true},
          {key: 'properties', sortable: true, filterable: false},
          {key: 'status', sortable: true, filterable: true},
          {key: 'details', sortable: true, filterable: true},
          {key: 'causer_id',  'label': 'Created by',sortable: true, filterable: true},
          {key: 'created_at', sortable: true, filterable: 'date'},
        ],
        actions: [
          {action: 'onShowImportTimesheetsReport', variant: 'outline-default', icon: this.$getConst.icons.file, permissions: [this.$getConst.permissions.importTimesheets]},
          {action: 'onShowImportInvoicesReport', variant: 'outline-default', icon: this.$getConst.icons.file, permissions: [this.$getConst.permissions.importInvoices]},
        ],
        scope: null,
        scopeIds: null,
        propertiesDetailsModal: 'properties-details-modal',
        detailsModal: 'details-modal',
        importTimesheetsReportModal: 'import-timesheets-rapport',
        importInvoicesReportModal: 'import-invoices-rapport',
        log: null,
        tableKey: 0
      }
    },
    created() {
      this.$store.getters['auth/allScopes'].forEach(scope => {
        this.scopeIds = this.scopeIds + "," + scope.id;
      });
      this.scopeIds = this.scopeIds.substring(5)
      this.endPoint = '/commandActivityLogs/' + this.scopeIds;
      this.getStatus();
    },
    methods: {
      changeScope() {
        if (this.scope) {
          this.endPoint = '/commandActivityLogs/' + this.scope.id;
        } else {
          this.endPoint = '/commandActivityLogs/' + this.scopeIds;
        }
      },
      showPropertiesDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.propertiesDetailsModal));
      },
      showDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.detailsModal));
      },
      showImportTimesheetsReportModal(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.importTimesheetsReportModal));
      },
      showImportInvoicesReportModal(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.importInvoicesReportModal));
      },
      showVendorReportButton(log) {
        return log.status == 'Report done' || log.status == 'Invalid data' || log.status == 'Import in progress' || log.status == 'Import done' || log.status == 'Import failed';
      },
      formatDate(date) {
        const formatD = formatDateByScope(date, this.$store.getters["auth/scopeDefault"].format_date, this.scope);
        return formatD;
      },
      getStatus() {
        getAllStatus().then(listOfAllStatus => {
          this.status = listOfAllStatus.data.data;
          this.updateStatusField(this.status);
        })
      },
      updateStatusField(status) {
        this.fields[3].filterable = status.map(status => {
          return {value: status, text: status};
        });
      },
    },
  }
</script>
